import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import { scale } from '@/utils';
import IconQuestionmark from '@/assets/icons/icon-questionmark.svg';

export const Container = styled.div`
  padding: 18px 12px 10px;
  display: flex;
`;

export const ImageSection = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-right: 20px;
`;

export const InfoSection = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const NoticeGrayBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px 20px;
  padding: 10px;
  background-color: ${colors.gray100};
`;

export const OrderlineContainer = styled.li`
  border-top: 1px solid ${colors.gray100};
  padding: ${scale.large};
  display: flex;
`;

export const Img = styled.img`
  object-fit: cover;
  width: 40px;
  height: 40px;
  border-radius: 4px;
`;

export const OrderItemsWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${colors.gray200};
  padding: 12px 10px;
  margin: 0 12px 16px;
`;

export const DeliveryFeeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 6px;
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const Icon = styled.div`
  position: relative;
  background-image: url(${IconQuestionmark});
  background-size: cover;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
